import ActionCable from 'actioncable';
import JwtService from './jwt.service';

export function subscribe(channel, id, callback) {
    const token = JwtService.getToken();
    const cable = ActionCable.createConsumer(`${process.env.VUE_APP_WEBSOCKET_URL}?token=${btoa(token)}`);
    return cable.subscriptions.create({ channel, id }, callback);
}

export function subscribeV2(channel, paramName, id, callback) {
    const token = JwtService.getToken();
    const cable = ActionCable.createConsumer(`${process.env.VUE_APP_WEBSOCKET_URL}?token=${btoa(token)}`);
    const params = {
        channel: channel,
        [paramName]: id,
    };
    return cable.subscriptions.create(params, callback);
}

export function unsubscribe(channel) {
    if (channel) {
        channel.unsubscribe();
    }
}

export default {
    subscribe,
    unsubscribe,
    subscribeV2,
};
